export const IsAmendment = (data) => {
  return data && data.parentIo;
};
